import {Entity} from '../../pages/product/product.model';

export class Report
{
    name: string;
    params: string;


    constructor(report?)
    {
        report = report || {};
        this.name = report.name;
        this.params = report.params;
    }
}


export class ReportParams{

    category: string;
    template: Report;
    from: string;
    to: string;
    projectId: number;
    inCharge: Entity;
    client: Entity;
    status: string;
    noDates: boolean;
    selected: string;

    constructor(){

    }

}
